import {
  InformationCircleIcon,
  MagnifyingGlassIcon
} from '@heroicons/react/24/outline';
import { useEffect, useState } from 'react';
import type { FormattedChannel } from '@library/types/alerts';
import { IconButton } from '@library/components/buttons';
import { Searchbar } from '@library/components/inputs';
import { SubscribeChannelButton } from '@bo-components/alerts/SubscribeChannelButton';

export interface ChannelHeaderProps {
  displayName: string;
  handleOpenDrawer: () => void;
  id: number;
  areNotificationsVisible: boolean;
  isUserSubscribedCheck: boolean;
  searchChannelValue: string;
  setChannels: (channels: Array<FormattedChannel>) => void;
  setIsUserSubscribedCheck: (subscribeCheck: boolean) => void;
  setSearchChannelValue: (value: string) => void;
}

export const ChannelHeader = ({
  displayName,
  handleOpenDrawer,
  id,
  areNotificationsVisible,
  isUserSubscribedCheck,
  searchChannelValue,
  setChannels,
  setSearchChannelValue,
  setIsUserSubscribedCheck
}: ChannelHeaderProps) => {
  const [isSearchbarVisible, setIsSearchbarVisible] = useState(false);
  const areNotificationsVisibleSummary = displayName === 'Notifications';

  useEffect(() => {
    setIsSearchbarVisible(false);
  }, [id]);

  return (
    <div className="text-soClean-100 bg-soFresh-100 flex h-[88px] justify-between px-7">
      <div className="flex gap-2">
        <p className="my-auto text-lg">{`${areNotificationsVisibleSummary ? '' : '#'}${displayName}`}</p>
        {!areNotificationsVisible && (
          <SubscribeChannelButton
            selectedChannelId={id}
            isUserSubscribedCheck={isUserSubscribedCheck}
            setChannels={setChannels}
            setIsUserSubscribedCheck={setIsUserSubscribedCheck}
          />
        )}
      </div>
      {!areNotificationsVisible && (
        <div className="text-soClean-100 flex items-center justify-center gap-2">
          {!isSearchbarVisible && (
            <IconButton
              className="m-auto flex size-10 content-center"
              handleOnClick={() => setIsSearchbarVisible(true)}
            >
              <MagnifyingGlassIcon className="m-auto size-5 self-center" />
            </IconButton>
          )}
          {isSearchbarVisible && (
            <div className="my-5 w-11/12">
              <Searchbar
                searchValue={searchChannelValue}
                handleSearch={setSearchChannelValue}
                placeholder="Search channels"
              />
            </div>
          )}
          <IconButton
            className="m-auto flex size-10 content-center"
            handleOnClick={handleOpenDrawer}
          >
            <InformationCircleIcon className="m-auto size-5 self-center" />
          </IconButton>
        </div>
      )}
    </div>
  );
};
